import React, { useState } from "react"
import { FiInfo } from "react-icons/fi"
import {
  Box,
  Link,
  UnorderedList,
  ListItem,
  Icon,
  IconButton,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Heading,
  Text,
  useDisclosure,
} from "@chakra-ui/react"

const StyledText: React.FC = ({ children }) => (
  <Text my={4} fontSize="lg">
    {children}
  </Text>
)
const Heading3: React.FC = ({ children }) => (
  <Heading as="h3" size="xl" mt={8} mb={4} _first={{ mt: 2 }}>
    {children}
  </Heading>
)

export const InfoModalButton: React.FC = ({ children }) => {
  const [ affiliatesOpen, setAffiliatesOpen ] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <>
      {children ? (
        <Link onClick={onOpen}>{children}</Link>
      ) : (
        <IconButton
          onClick={onOpen}
          variant="ghost"
          icon={<Icon as={FiInfo} fontSize="lg" />}
          aria-label="Show information"
        />
      )}

      {/*@TODO add padding and maybe hide focus state on close button? */}
      <Modal isOpen={isOpen} onClose={onClose} size="4xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader />
          <ModalCloseButton />
          <ModalBody>
            <Box sx={{display: affiliatesOpen ? "block" : "none"}}>
              <p><Link href="https://amzn.to/3govdLj" target="_blank">reflective tape</Link></p>
              <p><Link href="https://amzn.to/3D4Cp9j" target="_blank">cube light</Link></p>
              <p><Link href="https://amzn.to/2Wl0YxY" target="_blank">window film</Link></p>
              <p><Link href="https://amzn.to/2Ye4sTQ" target="_blank">extension cord</Link></p>
            </Box>
            <Heading3><span onClick={() => setAffiliatesOpen(!affiliatesOpen)}>Where do I start?</span></Heading3>
            <StyledText>
              PLYGRND aims to help you enjoy life. Here, you can find resources
              to help you plan your trip, whether alone or with friends.
            </StyledText>
            <StyledText>
              You can create a custom trip plan by choosing the mood and setting
              and selecting a list of activities you want for your experience.
              Note that some activities require planning in advance. If you
              choose to enjoy your experience later, your options for activities
              will include materials you can acquire before your experience.
            </StyledText>
            <Heading3>How do I structure my trip? </Heading3>
            <StyledText>
              Our thoughts and emotions influence how we experience reality.
            </StyledText>
            <StyledText>
              Each experience starts with a Ceremony. The Ceremony helps you set
              an intention for the trip, and take a moment to acknowledge the
              start of the experience. While we include a Ceremony for each
              experience, feel free to make it your own.
            </StyledText>
            <StyledText>
              To set your intention, consider what you want to get out of the
              trip. How do you want to feel? Is there a topic you want to hold
              in the back of your mind? What is your goal?
            </StyledText>
            <StyledText>Examples of intentions are:</StyledText>
            <UnorderedList>
              <ListItem>To feel free</ListItem>
              <ListItem>To show my partner I care about them</ListItem>
              <ListItem>To enjoy myself</ListItem>
              <ListItem>To Create</ListItem>
            </UnorderedList>
            <StyledText>
              If you are taking creative substances, consider the impact they
              may have on your physiology. Some activities may not be suitable
              to conduct at the peak of an experience. Some might be more
              suitable for the come-down. Include these considerations in your
              plans
            </StyledText>

            <Heading3>Always good to consider</Heading3>
            <StyledText>
              Make sure you are in a safe, comfortable environment
            </StyledText>
            <StyledText>Spend this time with people you trust</StyledText>
            <StyledText>
              If you are alone, let someone know your plans in advance and make
              sure you have someone you can call
            </StyledText>
            <StyledText>Drink water</StyledText>
            <StyledText>Wear comfortable clothes</StyledText>
            <StyledText>Take a couple deep breaths to relax</StyledText>
            <StyledText>
              Exercising beforehand helps your body feel good during the trip.
              Try a 20 minute Yoga before you start.
            </StyledText>
            <StyledText>
              Prepare the materials in advance so you starting any activity is
              effortless during your trip
            </StyledText>
            <StyledText>
              Before you begin your trip, write a note to yourself that you are
              safe so you can use it to calm yourself i you are struggling
            </StyledText>

            <Heading3>Useful resources</Heading3>
            <StyledText>
              <Link isExternal href="https://maps.org/">
                MAPS: Multidisciplinary Association for Psychedelic Studies
              </Link>
            </StyledText>
            <StyledText>
              <Link isExternal href="https://zendoproject.org/resources/">
                Zendo Project: Helping people through challenging experiences
              </Link>
            </StyledText>
            <StyledText>
              <Link isExternal href="https://psychedelic.support/">
                Psychedelic support
              </Link>
            </StyledText>
            <StyledText>
              <Link isExternal href="https://www.erowid.org/">
                Erowid: Documenting the complex relationship between humans and
                psychoactives
              </Link>
            </StyledText>
            <StyledText>
              <Link
                isExternal
                href="https://onedeepbreath.io/patterns/tactical-breathing-animation-gif/"
              >
                Breath visualization
              </Link>
            </StyledText>
            <StyledText>
              <Link isExternal href="https://psychonautwiki.org/">
                Psychonaut wiki
              </Link>
            </StyledText>
          </ModalBody>

          <ModalFooter />
        </ModalContent>
      </Modal>
    </>
  )
}
